import { Typography, TypographyProps } from '@ethings/ui-toolkit';
import { Variant } from '@mui/material/styles/createTypography';
import { FC, type JSX } from 'react';

export interface FormatAddressProps {
  addressUnavailableText?: string;
  'data-testid'?: string;
  value?: string[];
  variant?: Variant;
  typographyProps?: TypographyProps;
}

export const FormatAddress: FC<FormatAddressProps> = ({ addressUnavailableText, value, variant = 'body2', typographyProps, ...props }): JSX.Element => {
  if (!value || !value.length) {
    return addressUnavailableText
      ? <Typography variant={variant} fontStyle="italic" data-testid={props['data-testid']} {...typographyProps}>{addressUnavailableText}</Typography>
      : <></>;
  }
  if (value.length === 1) return <Typography data-testid={props['data-testid']} variant={variant} {...typographyProps}>{value[0]}</Typography>;
  return <Typography variant={variant} data-testid={props['data-testid']} {...typographyProps}>{value.join(', ')}</Typography>;
};
